// extracted by mini-css-extract-plugin
export default {"webInput":"GlobalSettings_webInput__yWYlD","required":"GlobalSettings_required__6LyMw","setting":"GlobalSettings_setting__BwYsI"};